// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/useAskV2ScriptedProgress.test.ts
import { type AskV2RailContent, type AskV2RailProgressItem } from "./types";

export function mergeScriptedRailProgress(
  base: AskV2RailContent,
  scripted: { items: AskV2RailProgressItem[]; showShell: boolean },
): AskV2RailContent {
  if (!scripted.showShell && scripted.items.length === 0) {
    return base;
  }

  return {
    ...base,
    progress: {
      status: base.progress?.status,
      items: scripted.items,
    },
  };
}
